module.exports = __webpack_public_path__ + "static/3m-a360b3e6b36e38bb0922376c15b1adec.jpg";